
export const networks = [
    {
        path: "#",
        name: "Instagram",
    },
    {
        path: "#",
        name: "Telegram",
    },
    {
        path: "#",
        name: "Facebook",
    },
    {
        path: "#",
        name: "Twitter",
    },

]


export const services = [
    {
        id: 1,
        text: "Graphic design"
    },
    {
        id: 2,
        text: "2d motion"
    },
    {
        id: 3,
        text: "3d motion"
    },
    {
        id: 4,
        text: "Modeling"
    }
]